export default "__VITE_ASSET__Bn6UQpLK__"